import { render } from "./RelatoriosVie.vue?vue&type=template&id=0aa3beea&scoped=true"
import script from "./RelatoriosVie.vue?vue&type=script&lang=js"
export * from "./RelatoriosVie.vue?vue&type=script&lang=js"

import "./RelatoriosVie.vue?vue&type=style&index=0&id=0aa3beea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aa3beea"]])

export default __exports__